import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { redirectToCARTPage, redirectToAddHopePage } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { resetOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import { isAddHopePurchase } from 'common/utilities/orderStatusUtils';
import { getPaymentFailedDisplayText } from 'components/paymentFailed/utils/paymentFailedUtils';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';

const { PAYMENT_FAILED_SCREEN_TEXT } = PAYMENT_CONSTANTS;

const PaymentFailedView = props => {
  const { isCardValidateFailedScreen } = props;
  return (
    <div className='PaymentFailedScreen au'>
      <div className='paymentFailed'>
        <div className='FailedDisplay'>
          <div className='Failimage'>
            <img src={IMAGE_PATH?.Issue} alt='issue img' />
          </div>
          <div className='notRight'>
            {getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.TITLE, isCardValidateFailedScreen)}
          </div>
          <div className='Reason col-sm-8 col-12'>
            {getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.DESCRIPTION, isCardValidateFailedScreen)}
          </div>
          <div className='backToCart'>
            <ButtonComp
              data-testid='Back-Cart-Button'
              className='button whiteButton blackBorder back-To-Cart'
              onClick={() => {
                props.dispatch(resetOrderAction());
                isAddHopePurchase() ? redirectToAddHopePage(props) : redirectToCARTPage(props, false);
              }}
            >
              {getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.BUTTON_TEXT, isCardValidateFailedScreen)}
            </ButtonComp>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaymentFailedView);
